import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Auth } from "@leagueplatform/auth";
import { GET_USER_PROFILE_MESSAGE_TYPE } from "@leagueplatform/user-profile-api";
import { useGetUserProfile } from "@leagueplatform/web-common";
import { setPostFtux } from "api/set-post-ftux";

export const useFtuxCompletion = () => {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useGetUserProfile();

  const ftuxComplete = isLoading
    ? undefined
    : Boolean((data as { ftuxComplete?: boolean } | undefined)?.ftuxComplete);

  const mutation = useMutation({
    mutationFn: async () => {
      const userId = await Auth.getUserId();
      if (!userId) throw new Error("ftux: missing userId");
      await setPostFtux({ user_id: userId, onboarding_complete: true });
      await queryClient.invalidateQueries({
        queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
      });
    },
  });

  return {
    ftuxComplete,
    isLoading,
    error: (error as Error | null) ?? mutation.error,
    markFtuxComplete: mutation.mutateAsync,
  };
};
